import React, { Component } from 'react';
import { shape, string, func } from 'prop-types';
import { Translate } from 'react-localize-redux';
import { connect } from 'react-redux';
import moment from 'moment';

import { Link } from 'react-router-dom';
import { getSurveyStats, markFeedbackAsViewed } from '../../api';

import styles from './surveySummary.module.css';
import SurveyQuestionSummary from '../SurveyQuestionSummary';
import SurveyVariableSummary from '../SurveyVariableSummary';
import { getTranslation, withLang } from '../../i18n';
import { addErrorMessageAction, setTaskPending, setTaskFulfilled } from '../../actions';
import { DISPLAY_DATE_FORMAT, LONG_DISPLAY_DATE_FORMAT, routes } from '../../constants';
import { autoFocusElementById, getCompiledPath, setDocumentTitle } from '../../util';
import { langType, surveyTypeValues } from '../../constants/types';
import withRouter from '../WithRouter';

const FEEDBACK_SUMMARY_TITLE = 'feedback_summary_title';

class SurveySummary extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {
    const { surveyId } = this.props.params;

    this.props.dispatchSetTaskPending();
    getSurveyStats(surveyId)
      .then((surveyStats) => {
        this.setState({ surveyStats });
        if (!surveyStats.userHasSeenFeedback) {
          markFeedbackAsViewed(surveyId);
        }
        autoFocusElementById(FEEDBACK_SUMMARY_TITLE);
      })
      .catch(this.props.dispatchAddErrorMessage)
      .finally(this.props.dispatchSetTaskFulfilled);
  }

  render() {
    const { lang } = this.props;
    const { surveyStats } = this.state;
    const title = `${this.props.translate('surveySummary.title')} - ${surveyStats ? getTranslation(surveyStats.survey.title, this.props.lang) : ''}`;
    setDocumentTitle(title);

    const renderSummaryComponent = () => {
      if (surveyStats.variableStatistics) {
        return (
          <SurveyVariableSummary
            surveyStats={surveyStats}
            lang={lang}
          />
        );
      }

      return (
        <SurveyQuestionSummary
          surveyStats={surveyStats}
        />
      );
    };

    return (
      <>
        {surveyStats && (
        <div className="page-container">
          <div className="flex-inline">
            <h1 className="page-title--small" id={FEEDBACK_SUMMARY_TITLE}>
              {title}
            </h1>
          </div>
          <span className={styles.feedbackCalculated}>
            <Translate id="surveySummary.feedbackComputedAt" /> {surveyStats.computationTime
              ? moment(surveyStats.computationTime).format(LONG_DISPLAY_DATE_FORMAT) : ''}
          </span>
          { renderSummaryComponent() }
          {[surveyTypeValues.DEGREE_PROGRAM_SURVEY].includes(surveyStats.survey.type) && (
          <>
            <h2><Translate id="surveySummary.ownResponse" /></h2>
            <Link
              className={styles.responseLink}
              to={getCompiledPath(routes.survey.feedback.responses, { surveyId: surveyStats.survey.id })}
            >
              <div className={styles.surveyType}>
                <p><Translate id={`surveyType.${surveyStats.survey.type}`} /></p>
              </div>
              <div className={styles.surveyTitle}>
                <p>{getTranslation(surveyStats.survey.title, lang)}</p>
              </div>
              <div className={styles.responseDate}>
                <p>
                  <Translate id="surveySummary.responseDate" />
                  {' '}
                  {surveyStats.responseTime ? moment(surveyStats.responseTime).format(DISPLAY_DATE_FORMAT) : ''}
                </p>
              </div>
            </Link>
          </>
          )}
        </div>
        )}
      </>
    );
  }
}

const mapDispatchToProps = (dispatch) => ({
  dispatchAddErrorMessage: (err) => dispatch(addErrorMessageAction(err)),
  dispatchSetTaskPending: () => dispatch(setTaskPending()),
  dispatchSetTaskFulfilled: () => dispatch(setTaskFulfilled())
});

SurveySummary.propTypes = {
  params: shape({
    surveyId: string
  }).isRequired,
  lang: string.isRequired,
  dispatchAddErrorMessage: func.isRequired,
  dispatchSetTaskPending: func.isRequired,
  dispatchSetTaskFulfilled: func.isRequired,
  ...langType
};

export default withRouter(withLang(connect(null, mapDispatchToProps)(SurveySummary)));
